import { render, staticRenderFns } from "./CarrierFedex.vue?vue&type=template&id=78980b3e&scoped=true&"
import script from "./CarrierFedex.vue?vue&type=script&lang=js&"
export * from "./CarrierFedex.vue?vue&type=script&lang=js&"
import style0 from "./CarrierFedex.vue?vue&type=style&index=0&id=78980b3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78980b3e",
  null
  
)

export default component.exports